// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"e7","speechCardBox":"e7","speech-img-box":"e8","speechImgBox":"e8","card-content":"e9","cardContent":"e9","card-src":"e-","cardSrc":"e-"};